import styled, {keyframes, css} from 'styled-components';
import {
    APPLY_ANIMATION,
    APPLY_BORDERS, APPLY_MAX_HEIGHT, APPLY_MODAL_CLOSING_ANIMATION,
    DISABLE_FULLSCREEN_MOBILE,
    FORCE_FULLSCREEN_TABLET,
    FORCE_TRANSPARENT_BACKGROUND, FORCE_TRANSPARENT_CONTENT_BACKGROUND,
} from '../../css-classes';
import {styledByDevice} from '../../../../themes/architecture/styled-by-device';
import { CssRule } from '../../../../themes/architecture/css-helpers/css-rule';
import {MODAL_DIALOG_ANIMATION_DURATION} from "./dialog-overlay-constants";



const showDialogKeyframes = keyframes`
     0% {
        transform: scale(0.9) translateY(-40%) translateZ(1000px) perspective(600px) rotateX(80deg);
     }

     100% {
        transform: scale(1) translateY(0) translateZ(1000px) perspective(600px) rotateX(0);
     }
`;

const closeDialogKeyFrames = keyframes`
     0% {
        transform: scale(1) translateY(0) translateZ(1000px) perspective(600px) rotateX(0);

     }

     100% {
        transform: scale(0.9) translateY(-40%) translateZ(1000px) perspective(600px) rotateX(80deg);
     }
`;

const showDialogAnimation = css`
    animation: ${showDialogKeyframes} ${MODAL_DIALOG_ANIMATION_DURATION}ms ease-in-out forwards;
`;

const closeDialogAnimation = css`
    animation: ${closeDialogKeyFrames} ${MODAL_DIALOG_ANIMATION_DURATION}ms ease-in-out forwards;
`;

const applyBorders = css`
    &.${APPLY_BORDERS} {
        overflow:hidden;
        border-width: 2px;
        border-style: solid;
        border-color: ${({theme}) => theme.colors.modalDialogBorder};
        border-radius: 10px;
    }
`;

const applyMaxHeight = css`
    &.${APPLY_MAX_HEIGHT} {
        max-height: 80%;
    }
`;

const DefaultBox = styled.div`
    display: flex;
    flex-direction: column;
    margin: 0;
    padding: 0;
    background-color: ${props => props.theme.colors.background};
    &.${FORCE_TRANSPARENT_CONTENT_BACKGROUND}{
         background-color: transparent;
    }
`;

const PcBox = styled(DefaultBox)`
   ${applyBorders}
   ${applyMaxHeight}
   &.${APPLY_ANIMATION} {
        ${showDialogAnimation};
   }
   &.${APPLY_MODAL_CLOSING_ANIMATION} {
        ${closeDialogAnimation}
   }
`;

const MobileBox = styled(DefaultBox)`
    height: 100%;
    width: 100%;
    .${FORCE_TRANSPARENT_BACKGROUND} & {
        height: auto;
    }
    ${CssRule.For.mobile.tablet.build()} & {
        :not(.${FORCE_FULLSCREEN_TABLET}) {
            height: auto;
            width: auto;
            ${applyBorders}
            ${applyMaxHeight}
        }
    }
    .${DISABLE_FULLSCREEN_MOBILE} & {
        height: auto;
        width: auto;
        max-width: calc(100% - 2rem);
        max-height: calc(100% - 2rem);
        ${applyBorders}
        ${applyMaxHeight}
    }

    &.${APPLY_ANIMATION} {
        ${CssRule.For.mobile.tablet.build()} & {
            ${showDialogAnimation};
        }
        .${DISABLE_FULLSCREEN_MOBILE} & {
            ${showDialogAnimation};
        }
    }
    
    &.${APPLY_MODAL_CLOSING_ANIMATION} {
        ${CssRule.For.mobile.tablet.build()} & {
            ${closeDialogAnimation};
        }
        .${DISABLE_FULLSCREEN_MOBILE} & {
            ${closeDialogAnimation};
        }
    }
`;

export const DialogOverlayContentDefaultBox = styledByDevice(PcBox, MobileBox);